import React, { useState, useEffect, useRef } from 'react';
import './editaddprojectmember.css';

const API_URL = process.env.REACT_APP_API_URL;

const EditAddProjectMember = ({ onClose, handleAddMember }) => {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        // Fetch users when component mounts
        fetchUsers();

        // Add click event listener to handle clicking outside dropdown
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
                inputRef.current && !inputRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${API_URL}/userlist`);
            const data = await response.json();
            setUsers(data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setShowDropdown(value.length > 0);
    };

    const handleSelectUser = (username) => {
        setSearchTerm(username);
        setShowDropdown(false);
    };

    const filteredUsers = users.filter(user =>
        user.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        formData.set('memberusername', searchTerm); // Use the selected username
        handleAddMember(event);
    };

    return (
        <div className="editaddmember-popup-container">
            <div className="editaddmember-popup">
                <button className='editaddmember-closeBtn' onClick={onClose}>
                    <i className="fa-solid fa-x" />
                </button>
                <div className="editaddmember-popupcontent">
                    <h2 style={{ fontWeight: '400' }}>Add Member</h2>
                    <form style={{ margin: '2rem 1rem' }} onSubmit={handleSubmit}>
                        <div className="username-input-container" style={{ position: 'relative' }}>
                            <input
                                type='text'
                                className='editaddmember-forminput'
                                name='memberusername'
                                placeholder='Username'
                                value={searchTerm}
                                onChange={handleSearch}
                                onFocus={() => setShowDropdown(searchTerm.length > 0)}
                                ref={inputRef}
                                required
                            />
                            {showDropdown && filteredUsers.length > 0 && (
                                <div 
                                    className="username-dropdown"
                                    ref={dropdownRef}
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        backgroundColor: 'white',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        zIndex: 1000,
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {filteredUsers.map((user) => (
                                        <div
                                        key={user.user_id}
                                        className="username-option"
                                        onClick={() => handleSelectUser(user.username)}
                                    >
                                        <span className="username-option-username">{user.username}</span>
                                        <span className="username-option-fullname">
                                            {user.first_name} {user.last_name}
                                        </span>
                                    </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <input 
                            type='text' 
                            className='editaddmember-forminput' 
                            name='memberrole' 
                            placeholder='Role' 
                            required 
                        />
                        <input 
                            type='submit' 
                            className='editaddmember-forminput' 
                            value='Add' 
                            style={{ 
                                backgroundColor: '#09CE78', 
                                color: 'white', 
                                paddingTop: '0.6rem', 
                                paddingBottom: '0.6rem', 
                                marginTop: '1rem' 
                            }} 
                        />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditAddProjectMember;